import { useContext, useEffect, useState } from "react";

import { CoreContext } from "context/CoreContext";
import {
  ButtonWrapper,
  CardExpandContainer,
  CardExpandContainerBody,
  CardExpandContainerHeader,
  CardExpandContainerHeaderContent,
  ModalContainerHeaderButton,
  ModalContainerHeaderButtonIcon,
} from "./styled";

import Button from "components/Form/Button";
import Input from "components/Form/Input";
import ErrorToast from "components/Toasts/Error";
import SuccessToast from "components/Toasts/Success";
import { Update } from "services/campaigns";

export default function CardAddSchedule({
  closeable,
  campaign,
  reload,
  typeModal,
}) {
  const [link, setLink] = useState(
    () =>
      campaign?.schedules?.[Object.keys(campaign?.schedules || {})?.[0]]
        ?.link || ""
  );
  const [title, setTitle] = useState(
    () =>
      campaign?.schedules?.[Object.keys(campaign?.schedules || {})?.[0]]
        ?.title || ""
  );
  const [sending, setSending] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const { user } = useContext(CoreContext);

  const changeLink = (value) => {
    setLink(getIframeSrc(value));
  };
  const getIframeSrc = (value) => {
    if (link.includes("<iframe")) {
      const div = document.createElement("div");
      div.innerHTML = value;
      const iframe = div.querySelector("iframe");
      return iframe ? iframe.src : null;
    }

    // Caso seja um link direto, retorna ele mesmo
    return value.trim();
  };

  const action = async () => {
    if (disabled) {
      return;
    }
    setSending(true);

    const id = crypto.randomUUID();
    const schedule = {
      id,
      link: getIframeSrc(link),
      title,
      createdAt: new Date(),
      createBy: user,
    };

    const result = await Update(
      {
        data: {
          schedules: {
            ...(typeModal !== "edit" && { ...campaign.schedule }),
            [schedule.id]: schedule,
          },
        },
      },
      campaign.id
    );

    if (!result?.error) {
      SuccessToast({
        message: ` Cronograma ${
          typeModal == "edit" ? "atualizado" : "adicionado"
        } com sucesso`,
      });

      closeable();

      setSending(false);

      await new Promise((resolve) => setTimeout(resolve, 2000));

      reload();
    } else {
      ErrorToast({ message: "Confira o link do cronograma " });
      setSending(false);
    }
  };

  useEffect(() => {
    if (!title || !link) {
      setDisabled(true);
      return;
    }

    setDisabled(false);
  }, [title, link]);

  return (
    <CardExpandContainer closeable={closeable}>
      <CardExpandContainerHeader>
        <CardExpandContainerHeaderContent></CardExpandContainerHeaderContent>
        {closeable ? (
          <ModalContainerHeaderButton>
            <Button outline nospace onClick={closeable}>
              <ModalContainerHeaderButtonIcon icon={"close"} />
            </Button>
          </ModalContainerHeaderButton>
        ) : null}
      </CardExpandContainerHeader>
      <CardExpandContainerBody>
        <h4>
          {typeModal === "edit" ? "Editar cronograma" : "Adicionar cronograma"}
        </h4>
        <div>
          <Input
            label={"Link do cronograma"}
            placeholder="Adicione o link da planilha"
            value={link}
            defaultValue={
              typeModal === "edit"
                ? campaign?.schedules[Object.keys(campaign?.schedules || {})[0]]
                    ?.link
                : ""
            }
            onChange={(e) => changeLink(e?.target?.value)}
            hasAsterisk
            infoIcon="Para obter o link, siga o seguinte processo. Arquivo>Compartilhar>Publicar na Web>Incorporar. Copie apenas o link do src sem as aspas duplas."
          />
          <Input
            label={"Título do cronograma"}
            placeholder="Adicione o título do cronograma"
            value={title}
            onChange={(e) => setTitle(e?.target?.value)}
            hasAsterisk
          />
          <ButtonWrapper disabled={disabled}>
            <Button
              primary
              loading={sending}
              onClick={action}
              marginRight={"12px"}
            >
              {typeModal === "edit"
                ? "EDITAR CRONOGRAMA"
                : "ADICIONAR CRONOGRAMA"}
            </Button>
          </ButtonWrapper>
        </div>
      </CardExpandContainerBody>
    </CardExpandContainer>
  );
}
